<template>
    <b-row align-h="start" no-gutters>
        <b-col cols="5">
            <multiselect
                v-model="month"
                :options="months"
                track-by="key"
                label="value"
                :multiple="false"
                placeholder="Mes"
                selectedLabel=""
                selectLabel=""
                deselectLabel=""
                @input="notifyChange">
            </multiselect>
        </b-col>

        <b-col align-self="center" class="px-1 text-center">
            de
        </b-col>

        <b-col cols="5">
            <multiselect
                v-model="year"
                :options="years"
                :multiple="false"
                placeholder="Año"
                selectedLabel=""
                selectLabel=""
                deselectLabel=""
                @input="notifyChange">
            </multiselect>
        </b-col>
    </b-row>
</template>

<script>
    import Multiselect from 'vue-multiselect';

    export default {
        name: "MonthAndYearSelector",
        components: {
            Multiselect
        },
        props: {
            value: Date
        },
        data() {
            return {
                months: [
                    {key: 0, value: 'Enero'},
                    {key: 1, value: 'Febrero'},
                    {key: 2, value: 'Marzo'},
                    {key: 3, value: 'Abril'},
                    {key: 4, value: 'Mayo'},
                    {key: 5, value: 'Junio'},
                    {key: 6, value: 'Julio'},
                    {key: 7, value: 'Agosto'},
                    {key: 8, value: 'Septiembre'},
                    {key: 9, value: 'Octubre'},
                    {key: 10, value: 'Noviembre'},
                    {key: 11, value: 'Diciembre'}
                ],
                month: null,
                years: [],
                year: null
            };
        },
        mounted() {
            let currentDateTime = new Date();
            for (let n = 0; n < 10; n++) {
                this.years.push(currentDateTime.getFullYear() + 5 - n);
            }

            this.initializeData(this.value);
        },
        methods: {
            initializeData(date) {
                this.month = date
                    ? this.months.find(month => (month.key == date.getMonth()))
                    : null;
                this.year = date
                    ? date.getFullYear()
                    : null;
            },
            notifyChange() {
                if (!!this.year && !!this.month) {
                    let issueDate = new Date(this.year, this.month.key, 1);
                    this.$emit('input', issueDate);
                } else {
                    this.$emit('input', null);
                }
            }
        },
        watch: {
            value: function () {
                this.initializeData(this.value);
            }
        }
    }
</script>

<style scoped>
</style>